module.exports = __webpack_public_path__ + "img/leftSider.a47c6336.png";